(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const posted =
      window.location.search.includes('newsletter=success') ||
      window.location.search.includes('customer_posted=true');
    let message = document.querySelector('.email-signup__message:not([hidden])');
    if (!message && posted) {
      message = document.querySelector('.email-signup__message--js');
      if (message) {
        message.hidden = false;
        setTimeout(() => {
          message.hidden = true;
        }, 5000);
      }
    }
    if (message) {
      message.scrollIntoView({ block: 'center' });
      message.focus({ preventScroll: true });
      if (posted) {
        history.replaceState(null, '', window.location.pathname);
      }
    }

    // #newsletter-Links (z. B. Announcement-Bar) gezielt zum Formular scrollen:
    // der native Ankersprung landet wegen content-visibility: auto im Footer zu kurz
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href$="#newsletter"]');
      if (!link) return;
      const target = document.getElementById('newsletter');
      if (!target) return;
      event.preventDefault();
      const formTarget = target.querySelector('.email-signup__form') || target;
      formTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const input = target.querySelector('.email-signup__input');
      if (input) input.focus({ preventScroll: true });
      // Nachrendernde Inhalte verschieben die Zielposition; nach dem Scroll korrigieren
      const settle = () => formTarget.scrollIntoView({ block: 'center' });
      if ('onscrollend' in window) {
        window.addEventListener('scrollend', settle, { once: true });
      } else {
        setTimeout(settle, 800);
      }
    });

    document.querySelectorAll('.email-signup__form').forEach((form) => {
      const success = form.querySelector('.email-signup__message--js');
      if (!success) return;
      let hideTimer;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('.email-signup__button');
        if (button) button.disabled = true;

        try {
          const response = await fetch(form.getAttribute('action'), {
            method: 'POST',
            body: new FormData(form),
            headers: { accept: 'text/html' },
          });
          const finalUrl = response.url || '';
          const posted = response.redirected || finalUrl.includes('customer_posted=true');

          if (response.ok && posted && !finalUrl.includes('/challenge')) {
            success.hidden = false;
            const input = form.querySelector('.email-signup__input');
            if (input) input.value = '';
            success.focus({ preventScroll: true });
            clearTimeout(hideTimer);
            hideTimer = setTimeout(() => {
              success.hidden = true;
            }, 5000);
          } else {
            form.submit();
          }
        } catch (error) {
          form.submit();
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-list-carousel-scrollbar"] && !Shopify.designMode) return;
  try {
    (function () {
    const SELECTOR = '[data-product-list-carousel-scrollbar]';
    const SCROLLER_SELECTOR =
      'slideshow-component[ref="resourceListCarousel"] slideshow-slides[ref="scroller"], slideshow-component[ref="resourceListCarouselMobile"] slideshow-slides[ref="scroller"]';

    /**
     * @param {HTMLElement} root
     */
    function initScrollbar(root) {
      const track = root.querySelector('.product-list-carousel-scrollbar__track');
      const thumb = root.querySelector('.product-list-carousel-scrollbar__thumb');
      const section = root.closest('.shopify-section');

      if (!track || !thumb || !section) return;

      /** @type {HTMLElement | null} */
      let activeScroller = null;

      const scrollers = () =>
        Array.from(section.querySelectorAll(SCROLLER_SELECTOR)).filter(
          (el) => el instanceof HTMLElement
        );

      function pickActiveScroller() {
        const list = scrollers();
        for (const el of list) {
          const r = el.getBoundingClientRect();
          if (r.width > 0 && r.height > 0) {
            return el;
          }
        }
        return null;
      }

      function updateFromScroller(scroller) {
        if (!scroller) {
          thumb.style.width = '0%';
          thumb.style.left = '0%';
          return;
        }

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const hasOverflow = maxScroll > 1;

        if (!hasOverflow) {
          thumb.style.width = '100%';
          thumb.style.left = '0%';
          return;
        }

        const thumbWidthPercent = (scroller.clientWidth / scroller.scrollWidth) * 100;
        const scrollRatio = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
        const thumbLeftPercent = scrollRatio * (100 - thumbWidthPercent);

        thumb.style.width = `${thumbWidthPercent}%`;
        thumb.style.left = `${thumbLeftPercent}%`;
      }

      function sync() {
        activeScroller = pickActiveScroller();
        updateFromScroller(activeScroller);
      }

      const onScroll = (event) => {
        const t = event.target;
        if (t instanceof HTMLElement) {
          updateFromScroller(t);
        }
      };

      const observers = [];

      function attach() {
        for (const el of scrollers()) {
          el.addEventListener('scroll', onScroll, { passive: true });
          const ro = new ResizeObserver(() => sync());
          ro.observe(el);
          observers.push({ el, ro });
        }
      }

      function detach() {
        for (const { el, ro } of observers) {
          el.removeEventListener('scroll', onScroll);
          ro.disconnect();
        }
        observers.length = 0;
      }

      attach();

      const winResize = () => sync();
      window.addEventListener('resize', winResize, { passive: true });

      let moTimeout = 0;
      const mo = new MutationObserver(() => {
        window.clearTimeout(moTimeout);
        moTimeout = window.setTimeout(() => {
          detach();
          attach();
          sync();
        }, 50);
      });
      mo.observe(section, { childList: true, subtree: true });

      const slideshows = section.querySelectorAll('slideshow-component[ref="resourceListCarousel"], slideshow-component[ref="resourceListCarouselMobile"]');
      for (const slideshow of slideshows) {
        const io = new MutationObserver(() => {
          window.requestAnimationFrame(() => sync());
        });
        io.observe(slideshow, { attributes: true, attributeFilter: ['in-viewport'] });
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => sync());
      });

      track.addEventListener('click', (event) => {
        const scroller = pickActiveScroller();
        if (!scroller) return;

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 0) return;

        const rect = track.getBoundingClientRect();
        const ratio = (event.clientX - rect.left) / rect.width;
        scroller.scrollLeft = ratio * maxScroll;
      });

      track.addEventListener('keydown', (event) => {
        const scroller = pickActiveScroller();
        if (!scroller) return;

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 0) return;

        const step = scroller.clientWidth * 0.2;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          scroller.scrollLeft = Math.min(maxScroll, scroller.scrollLeft + step);
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          scroller.scrollLeft = Math.max(0, scroller.scrollLeft - step);
        }
      });

      sync();
    }

    function initAll(root) {
      const scope = root || document;
      for (const el of scope.querySelectorAll(SELECTOR)) {
        if (!(el instanceof HTMLElement)) continue;
        if (el.dataset.scrollbarInit === 'true') continue;
        el.dataset.scrollbarInit = 'true';
        initScrollbar(el);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        initAll(event.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
